module.exports = "/images/deleted.png?5ee73b45a4f458e2c58a644c820a9d64";